/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState, useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getPaginationRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { APIContext } from "../../api";
import { Link } from "react-router-dom";
import { Line } from "react-chartjs-2";
import profilePhoto from "../../assets/profile_photo.svg";
import editIcon from "../../assets/Edit.svg";
import "chartjs-adapter-date-fns";
import { Menu, MenuButton, MenuList, MenuItem, Button, InputGroup, InputLeftElement, Input } from "@chakra-ui/react";
import { Select as ChakraSelect } from "chakra-react-select";
import { ChevronDownIcon, SearchIcon as ChakraSearchIcon } from "@chakra-ui/icons";
import HelmetLayout from "../../components/HelmetLayout";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale,
  Legend,
} from "chart.js";
import { PulseLoader } from "react-spinners";
import { getGravatarUrl } from "../../utils";
import DateDisplay from "../../components/ui-kit/date-display";
import classNames from "classnames";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale,
  Legend
);

function Users() {
  const [userList, setUserList] = useState([]);
  const [userDataAnalytics, setUserDataAnalytics] = useState([]);
  const { getUserDetails, getAnalyticsData, downloadUserList, getAvailableAddons } = useContext(APIContext);
  const [dateOffset, setDateOffset] = useState(30);
  const [searchUser, setSearchUser] = useState("");

  const [isDownloadingUsers, setIsDownloadingUsers] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);
  const [addonDetails, setAddonDetails] = useState({}); // Store addon ID to name mapping
  const [isLoadingAddons, setIsLoadingAddons] = useState(true);
  const [addonError, setAddonError] = useState(false);

  const downloadTableData = () => {
    // Get all filtered rows (not just current page)
    const allRows = table.getPrePaginationRowModel().rows;
    
    // Convert table data to CSV format
    const headers = columns.map(col => col.header).join(',');
    const csvData = allRows.map(row => {
      return columns.map(col => {
        let value;
        
        // Handle date columns specifically
        if (col.id === 'created') {
          const date = row.original?.UserCreateDate ? new Date(row.original.UserCreateDate) : null;
          value = date ? date.toISOString() : '';
        } else if (col.id === 'last_login') {
          const ts = row.original?.lastLoginTime ? row.original.lastLoginTime * 1000 : row.original?.UserCreateDate ? new Date(row.original.UserCreateDate).getTime() : 0;
          const date = ts ? new Date(ts) : null;
          value = date ? date.toISOString() : '';
        } else {
          // Use accessorFn for other columns
          value = col.accessorFn ? col.accessorFn(row.original) : row.getValue(col.id);
        }
        
        // Escape commas and quotes in CSV
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value || '';
      }).join(',');
    }).join('\n');
    
    const csvContent = `${headers}\n${csvData}`;
    
    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `users_export_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // SaasZilla toggle removed; use Plan filter directly
  const [sorting, setSorting] = useState([{ id: "created", desc: true }]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });
  const [globalFilter, setGlobalFilter] = useState("");
  const [columnFilters, setColumnFilters] = useState([]);
  // removed status/account filters
  const [planFilter, setPlanFilter] = useState([]); // [plan ids]
  const [addonFilter, setAddonFilter] = useState([]); // [addon names]

  const getStartDate = (offset = 30) => {
    const today = new Date();
    const startDate = new Date();

    startDate.setDate(today.getDate() - offset);
    return startDate.toLocaleDateString("en-CA");
  };

  const dateString = getStartDate(dateOffset);

  useEffect(() => {
    setIsLoadingUsers(true);
    getUserDetails()
      .then((user) => {

        // Sort users by UserCreateDate
        user.sort((a, b) => {
          return new Date(b.UserCreateDate) - new Date(a.UserCreateDate);
        });

        setUserList(user);
      })
      .catch((error) => {
        console.log(error.message);
      })
      .finally(() => {
        setIsLoadingUsers(false);
      });
  }, []);

  useEffect(() => {
    // Fetch addon details to map IDs to names
    setIsLoadingAddons(true);
    getAvailableAddons()
      .then((addons) => {
        const addonMap = {};
        addons.forEach(addon => {
          addonMap[addon.pk?.replace("plan-addon-", "") || addon.id] = addon;
        });
        setAddonDetails(addonMap);
      })
      .catch((error) => {
        console.log("Error fetching addon details:", error.message);
        setAddonError(true);
      })
      .finally(() => {
        setIsLoadingAddons(false);
      });
  }, []);

  useEffect(() => {
    getAnalyticsData(dateString)
      .then((usersdata) => {
        setUserDataAnalytics(usersdata);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, [dateOffset]);

  const userCounts = userDataAnalytics?.map((item) => item.user_count);
  const newUsersCounts = userDataAnalytics?.map((item) => item.new_users_count);
  const chartLabels = userDataAnalytics?.map((item) => item.sk);

  const data = {
    labels: chartLabels,
    datasets: [
      {
        label: "Users",
        data: userCounts,
        fill: false,
        spanGaps: true,
        backgroundColor: "#5CBB23",
        borderColor: "#5CBB23",
        borderWidth: 2,
        tension: 0.3,
        pointRadius: 0,
      },
      {
        label: "New Users",
        data: newUsersCounts,
        fill: false,
        spanGaps: true,
        backgroundColor: "#8593ED",
        borderColor: "#8593ED",
        borderWidth: 2,
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    plugins: {
      legend: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: "time",
        parsing: false,
        time: {
          unit: "day",
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
    },
  };

  const getCollaboratorCount = (user) => {
    try {
      const selfSub = user?.attributes_parsed?.sub;
      const projects = Array.isArray(user?.projects) ? user.projects : [];
      let total = 0;
      for (const project of projects) {
        const members = project?.members ? Object.keys(project.members) : [];
        if (members.length === 0) continue;
        total += Math.max(0, members.length - (selfSub && members.includes(selfSub) ? 1 : 0));
      }
      return total;
    } catch (_) {
      return 0;
    }
  };

  // custom filter to allow array of allowed values (used for SaasZilla plans)
  const inArrayFilter = React.useCallback((row, columnId, filterValue) => {
    const v = row.getValue(columnId);
    if (Array.isArray(filterValue)) return filterValue.includes(v);
    return v === filterValue;
  }, []);

  // custom filter for addons that checks if user has any of the selected addon names
  const addonFilterFn = React.useCallback((row, columnId, filterValue) => {
    if (!Array.isArray(filterValue) || filterValue.length === 0) return true;
    const user = row.original;
    const userAddons = user?.addons || [];
        // Check if user has any of the selected addon names
    return filterValue.some(selectedAddonName => {
      return userAddons.some(userAddon => userAddon.addonid === selectedAddonName);
    });
  }, [addonDetails]);

  const totalItems = useMemo(() => {
    // this will be updated post-table creation; fallback here is raw list length
    return Array.isArray(userList) ? userList.length : 0;
  }, [userList]);

  const columns = useMemo(
    () => [
      {
        id: "email",
        header: "Email",
        accessorFn: (user) => user?.attributes_parsed?.email || "",
        enableGlobalFilter: true,
        cell: (info) => {
          const email = info.row.original?.attributes_parsed?.email;
          return (
            <div className="flex items-center gap-2">
              <img
                src={getGravatarUrl(email)}
                className="w-[28px] h-[28px] rounded-full"
                alt="user"
              />
              <div className="max-w-[280px] truncate">{email}</div>
            </div>
          );
        },
      },
      {
        id: "name",
        header: "Name",
        accessorFn: (user) => {
          const given = user?.attributes_parsed?.["custom:given_name"] || user?.attributes_parsed?.["given_name"] || "";
          const family = user?.attributes_parsed?.["custom:family_name"] || user?.attributes_parsed?.["family_name"] || "";
          return `${given} ${family}`.trim();
        },
      },
      {
        id: "created",
        header: "Created",
        accessorFn: (user) => (user?.UserCreateDate ? new Date(user.UserCreateDate).getTime() : 0),
        cell: (info) => {
          const created = info.row.original?.UserCreateDate ? new Date(info.row.original.UserCreateDate) : null;
          return created ? <DateDisplay date={created} /> : "-";
        },
      },
      {
        id: "last_login",
        header: "Last Login",
        accessorFn: (user) => (user?.lastLoginTime ? new Date(user.lastLoginTime).getTime() : user?.UserCreateDate ? new Date(user.UserCreateDate).getTime() : 0),
        cell: (info) => {
          const ts = info.row.original?.lastLoginTime ? info.row.original?.lastLoginTime * 1000 : info.row.original?.UserCreateDate ? new Date(info.row.original.UserCreateDate).getTime() : 0;
          const date = ts ? new Date(ts) : null;
          return date ? <DateDisplay date={date} /> : "-";
        },
      },
      {
        id: "plan",
        header: "Plan",
        accessorFn: (user) => (user?.subscription?.status === "active" ? user?.subscription?.plan || "-" : "Free"),
        filterFn: inArrayFilter,
        cell: (info) => info.getValue(),
      },
      {
        id: "addons",
        header: "Addons",
        accessorFn: (user) => {
          const addons = user?.addons || [];
          if (addons.length === 0) return 'None';
          
          const addonNames = addons.map(addon => {
            const addonDetail = addonDetails[addon.addonid];
            return addonDetail?.name || addonDetail?.addon_name || 'Unknown';
          });
          return addonNames.join(', ');
        },
        filterFn: addonFilterFn,
        cell: (info) => {
          const addons = info.row.original?.addons || [];
          if (addons.length === 0) {
            return <span className="text-gray-400 text-sm">None</span>;
          }
          
          // Show loading state while addon details are being fetched
          if (isLoadingAddons) {
            return <span className="text-gray-400 text-sm">Loading...</span>;
          }

          // Show error state if addon details failed to load
          if (addonError) {
            return <span className="text-red-500 text-sm">Error loading addons</span>;
          }
          
          // If there are many addons, show first 2 + count
          const maxVisible = 2;
          const visibleAddons = addons.slice(0, maxVisible);
          const remainingCount = addons.length - maxVisible;
          
          return (
            <div className="flex flex-wrap gap-1 items-center">
              {visibleAddons.map((addon, index) => {
                const addonDetail = addonDetails[addon.addonid];
                const addonName = addonDetail?.name || addonDetail?.addon_name || 'Unknown';
                return (
                  <span
                    key={index}
                    className="px-2 py-1 text-xs bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 rounded-lg border border-blue-200 font-medium"
                    title={addonDetail?.description || addonName}
                  >
                    {addonName}
                  </span>
                );
              })}
              {remainingCount > 0 && (
                <span
                  className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded-lg border border-gray-200 font-medium"
                  title={addons.slice(maxVisible).map(addon => {
                    const addonDetail = addonDetails[addon.addonid];
                    return addonDetail?.name || addonDetail?.addon_name || 'Unknown';
                  }).join(', ')}
                >
                  +{remainingCount}
                </span>
              )}
            </div>
          );
        },
      },
      // removed status column per request
      {
        id: "websites",
        header: "Websites",
        accessorFn: (user) => user?.projects?.length || 0,
      },
      {
        id: "shared",
        header: "Shared Websites",
        accessorFn: (user) => user?.shared_projects?.length || 0,
      },
      {
        id: "collaborators",
        header: "Collaborators",
        accessorFn: (user) => getCollaboratorCount(user),
      },
      // removed enabled column per request
    ],
    [inArrayFilter, addonFilterFn]
  );

  const table = useReactTable({
    data: Array.isArray(userList) ? userList : [],
    columns,
    state: { sorting, pagination, globalFilter, columnFilters },
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  // recompute total after filters
  const filteredTotal = table.getPrePaginationRowModel().rows.length;

  const planOptions = useMemo(() => {
    const set = new Set();
    for (const u of userList || []) {
      if (u?.subscription?.status === "active" && u?.subscription?.plan) {
        set.add(u.subscription.plan);
      }
    }
    return Array.from(set).sort();
  }, [userList]);

  const addonOptions = useMemo(() => {
    if (addonError) return [];
    
    const set = new Set();
    for (const u of userList || []) {
      if (u?.addons && Array.isArray(u.addons)) {
        for (const addon of u.addons) {
          const addonDetail = addonDetails[addon.addonid];
          const addonName = addonDetail?.name || addonDetail?.addon_name;
          if (addonName) {
            set.add(addonName);
          }
        }
      }
    }
    return Array.from(set).sort();
  }, [userList, addonDetails, addonError]);

  // header rendering handled by TanStack table

  return (
    <>
      <HelmetLayout title="Users" />
      <div className="font-Poppins flex-1 h-screen overflow-y-scroll bg-white items-start p-7">
        <div className="flex flex-col justify-center items-start">
          <div className="w-full flex flex-row justify-between mb-6">
            <h1 className="text-[32px]">Users</h1>
            <img
              src={profilePhoto}
              className="mr-4 h-9"
              alt="user-profile-img"
            />
          </div>

          {/* Card Section */}

          <div className="flex flex-wrap justify-center items-center m-5 ml-0 gap-[14px] ">
            <div className="rounded-[29px] shadow-card-box-shadow">
              <div className="w-[255px] h-[100px] flex flex-col justify-center items-center">
                <div className="flex flex-col items-start">
                  <h1 className="font-bold">
                    {
                      userDataAnalytics.map((item) => item.new_users_count).reduce((a, b) => {
                        return (parseInt(a ?? 0)) + (parseInt(b ?? 0));
                      }, 0)
                    }
                  </h1>
                  <p>New Users</p>
                </div>
              </div>
            </div>
            <div className="rounded-[29px] shadow-card-box-shadow">
              <div className="w-[255px] h-[100px] flex flex-col justify-center items-center">
                <div className="flex flex-col items-start">
                  <h1 className="font-bold">
                    {
                      userDataAnalytics[userDataAnalytics.length - 1]
                        ?.user_count
                    }
                  </h1>
                  <p>Total Users</p>
                </div>
              </div>
            </div>
          </div>

          {/* Chartjs section */}

          <div className="w-full h-[420px] flex flex-col justify-center items-start shadow-card-box-shadow my-10 rounded-[20px] px-4 py-7 bg-[#FEFEFF]">
            <Menu>
              <MenuButton
                as={Button}
                my={3}
                variant=""
                borderRadius="20px"
                rightIcon={<ChevronDownIcon />}
              >
                Last {dateOffset} Days
              </MenuButton>
              <MenuList borderRadius="20px">
                <MenuItem
                  onClick={() => {
                    setDateOffset(7);
                  }}
                >
                  Last 7 days
                </MenuItem>
                <MenuItem onClick={() => setDateOffset(15)}>
                  Last 15 days
                </MenuItem>
                <MenuItem onClick={() => setDateOffset(30)}>
                  Last 30 days
                </MenuItem>
                <MenuItem onClick={() => setDateOffset(60)}>
                  Last 60 days
                </MenuItem>
              </MenuList>
            </Menu>
            <Line data={data} options={options} />
          </div>

          {/* Users Search + Actions */}

          <div className="flex flex-row justify-between w-full items-center my-7 gap-x-4">
            <div className="flex flex-row items-center gap-4">
              <h1 className="text-[24px] font-normal">All Users</h1>
            </div>
            <div>
              <button onClick={() => {
                downloadTableData();
              }} className="grigora-action-btn">
                Download
              </button>
            </div>
          </div>

          {/* Users Table with Pagination */}
          <div className="w-full bg-[#FEFEFF] shadow-card-box-shadow rounded-[20px] p-4">
            <div className="flex flex-wrap items-center gap-3 justify-between mb-3">
              <div className="flex items-center gap-3 flex-wrap flex-1">
                <div className="flex items-center gap-2">
                  <label className="text-sm text-gray-600 whitespace-nowrap">Plan</label>
                  <div className="min-w-[200px]">
                    <ChakraSelect
                      isMulti
                      size="sm"
                      useBasicStyles
                      placeholder="All"
                      value={planFilter.map((v) => ({ label: v, value: v }))}
                      onChange={(vals) => {
                        const selected = (vals || []).map((o) => o.value);
                        setPlanFilter(selected);
                        setColumnFilters((prev) => {
                          const others = prev.filter((f) => f.id !== "plan");
                          if (selected.length === 0) return others;
                          return [...others, { id: "plan", value: selected }];
                        });
                        table.setPageIndex(0);
                      }}
                      options={planOptions.map((p) => ({ label: p, value: p }))}
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <label className="text-sm text-gray-600 whitespace-nowrap">Addons</label>
                  <div className="min-w-[200px]">
                    <ChakraSelect
                      isMulti
                      size="sm"
                      useBasicStyles
                      placeholder="All Addons"
                      value={addonFilter.map((v) => ({ label: addonDetails[v]?.name || addonDetails[v]?.addon_name || v, value: v }))}
                      onChange={(vals) => {
                        const selected = (vals || []).map((o) => o.value);
                        setAddonFilter(selected);
                        setColumnFilters((prev) => {
                          const others = prev.filter((f) => f.id !== "addons");
                          if (selected.length === 0) return others;
                          return [...others, { id: "addons", value: selected }];
                        });
                        table.setPageIndex(0);
                      }}
                      options={Object.keys(addonDetails)?.map((a) => ({ label: addonDetails[a]?.name || addonDetails[a]?.addon_name || a, value: a }))}
                    />
                  </div>
                </div>
                {/* Status filter removed */}
                {/* Account filter removed */}
                {/* Global search placed here using Chakra UI */}
                <InputGroup size="sm" width="260px">
                  <InputLeftElement pointerEvents="none">
                    <ChakraSearchIcon color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Search..."
                    value={globalFilter ?? ""}
                    onChange={(e) => { setGlobalFilter(e.target.value); table.setPageIndex(0); }}
                    borderRadius="full"
                    bg="white"
                  />
                </InputGroup>
              </div>
              <div className="flex items-center gap-3">
                <label className="text-sm text-gray-600">Rows</label>
                <select
                  className="rounded-3xl px-3 py-2 bg-white shadow-input-tag text-sm"
                  value={table.getState().pagination.pageSize}
                  onChange={(e) => { table.setPageSize(parseInt(e.target.value)); table.setPageIndex(0); }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
            <div className="overflow-auto">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-50">
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          onClick={header.column.getToggleSortingHandler()}
                          className="px-4 py-2 text-left text-sm font-semibold cursor-pointer"
                        >
                          <div className="flex items-center gap-1">
                            <span>{flexRender(header.column.columnDef.header, header.getContext())}</span>
                            <span className="text-gray-400 text-xs">
                              {header.column.getIsSorted() === "asc"
                                ? "▲"
                                : header.column.getIsSorted() === "desc"
                                ? "▼"
                                : ""}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {isLoadingUsers && (
                    <tr>
                      <td colSpan={columns.length} className="px-4 py-10 text-center">
                        <div className="flex items-center justify-center">
                          <PulseLoader size={10} />
                        </div>
                      </td>
                    </tr>
                  )}
                  {table.getRowModel().rows.map((row) => (
                    <tr
                      key={row.id}
                      className="hover:bg-gray-50 cursor-pointer"
                      onClick={() => window.open(`/users/${row.original?.attributes_parsed?.sub}`, "_blank")}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-4 py-2 whitespace-nowrap">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                  {!isLoadingUsers && table.getRowModel().rows.length === 0 && (
                    <tr>
                      <td colSpan={columns.length} className="px-4 py-6 text-center text-gray-500">
                        No users found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="flex items-center justify-between mt-4">
              <div className="text-sm text-gray-600">
                {filteredTotal > 0 ? (
                  <>Showing {pagination.pageIndex * pagination.pageSize + 1} - {Math.min((pagination.pageIndex + 1) * pagination.pageSize, filteredTotal)} of {filteredTotal}</>
                ) : (
                  <>Showing 0 of 0</>
                )}
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="rounded-3xl px-3 py-1 bg-white shadow-input-tag text-sm disabled:opacity-50"
                  onClick={() => table.setPageIndex(0)}
                  disabled={!table.getCanPreviousPage()}
                >
                  « First
                </button>
                <button
                  className="rounded-3xl px-3 py-1 bg-white shadow-input-tag text-sm disabled:opacity-50"
                  onClick={() => table.previousPage()}
                  disabled={!table.getCanPreviousPage()}
                >
                  ‹ Prev
                </button>
                <span className="text-sm">Page {table.getState().pagination.pageIndex + 1} / {table.getPageCount()}</span>
                <button
                  className="rounded-3xl px-3 py-1 bg-white shadow-input-tag text-sm disabled:opacity-50"
                  onClick={() => table.nextPage()}
                  disabled={!table.getCanNextPage()}
                >
                  Next ›
                </button>
                <button
                  className="rounded-3xl px-3 py-1 bg-white shadow-input-tag text-sm disabled:opacity-50"
                  onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                  disabled={!table.getCanNextPage()}
                >
                  Last »
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default Users;
